import { useUpdateUserWishlistMutation, useWishlistQuery } from '@generated'
import { useMe } from './use-me'

export function useWishlistData() {
  // This will be updated in the future to load a specific wishlist based on an ID
  const { isLoading, isLoggedIn } = useMe()
  const [{ data }] = useWishlistQuery({
    pause: !isLoggedIn || isLoading,
  })

  const wishlist = data?.wishlist

  const [, updateWishlistMutation] = useUpdateUserWishlistMutation()
  // Currently a user can only have one wishlist

  return {
    wishlist,
    updateWishlist: (articleIds: string[]) =>
      wishlist &&
      updateWishlistMutation({
        articleIds: articleIds,
        status: wishlist.status,
      }),
  }
}
